import { render, staticRenderFns } from "./ModalContacts.vue?vue&type=template&id=da2ad74e&scoped=true&"
import script from "./ModalContacts.vue?vue&type=script&lang=js&"
export * from "./ModalContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2ad74e",
  null
  
)

export default component.exports